/**
 * Price History page - main page for viewing gold price history
 */

import { SectionErrorBoundary } from '@/components/common/SectionErrorBoundary'
import { PriceHistoryFilter } from '@/components/prices/PriceHistoryFilter'
import { PriceHistoryList } from '@/components/prices/PriceHistoryList'
import { PriceHistoryVolatilityPanel } from '@/components/prices/PriceHistoryVolatilityPanel'
import { Button } from '@/components/ui/button'
import { usePriceHistory, type PriceHistoryFilters } from '@/services/api/prices'
import { useState } from 'react'

export default function PriceHistory() {
  const [filters, setFilters] = useState<PriceHistoryFilters>({
    branchName: 'Hồ Chí Minh',
  })
  const [showRawList, setShowRawList] = useState(false)

  const { data: prices = [], isLoading } = usePriceHistory(filters)

  return (
    <div className="container mx-auto px-3 sm:px-4 py-4 sm:py-6 lg:py-8">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-6 sm:mb-8">
        <h1 className="text-2xl sm:text-3xl font-bold text-foreground">Lịch sử Giá Vàng</h1>
      </div>

      <PriceHistoryFilter onFilterChange={setFilters} />

      <div className="mt-4 flex items-center justify-between gap-2">
        <h2 className="text-lg font-semibold">Bảng giá chi tiết</h2>
        <Button
          variant="outline"
          size="sm"
          className="shrink-0 h-11 min-h-[44px]"
          onClick={() => setShowRawList(v => !v)}
        >
          {showRawList ? 'Ẩn bảng' : 'Xem bảng'}
        </Button>
      </div>
      {showRawList ? (
        <SectionErrorBoundary sectionName="Danh sách giá">
          <PriceHistoryList prices={prices} isLoading={isLoading} />
        </SectionErrorBoundary>
      ) : null}

      <SectionErrorBoundary sectionName="Báo cáo biến động">
        <div className="mt-6">
          <PriceHistoryVolatilityPanel />
        </div>
      </SectionErrorBoundary>
    </div>
  )
}
